import { render, staticRenderFns } from "./TheDarkFooter.vue?vue&type=template&id=6adaa5e9&"
import script from "./TheDarkFooter.vue?vue&type=script&lang=js&"
export * from "./TheDarkFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports